import { render, staticRenderFns } from "./NavikeyHome.vue?vue&type=template&id=5bd43b61"
import script from "./NavikeyHome.vue?vue&type=script&lang=js"
export * from "./NavikeyHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports